<template>
  <v-app>
    <toolbarandsidenav 
    v-if='this.$route.path !== "/login" && this.$route.path !== "/register" && this.$route.path !== "/" && this.$route.name !== "FightPage" && this.$route.name !== "RegisterFrontEnd" && this.$route.name !== "PastFights" && this.$route.name !== "UpcomingFights" && this.$route.name !== "CurrentFights"'/>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import Toolbarandsidenav from './components/navcomponents/toolbarandsidenav.vue';
import { getAuth, onAuthStateChanged } from "firebase/auth";
// import { doc, getDoc } from "firebase/firestore";
// import db from './firebaseConfig'
// import { mapGetters, mapState } from 'vuex';
// import firebase from 'firebase/compat/app';

export default {
  name: 'App',

  data: () => ({
    //
  }),
  components: {
    Toolbarandsidenav
  },

  created() {
    const auth = getAuth();
      onAuthStateChanged(auth, (user) => {

        if(user && user.emailVerified) {
          let signedin = true;
          let voutinguid = user.uid
           console.log('user', user.uid)
          this.$store.dispatch('setUser', user);
          this.$store.dispatch('setSignedIn', signedin);
          this.$store.dispatch('setgetallfighters')
          this.$store.dispatch('setgetfights')
          this.$store.dispatch('setgetfightsjoin')
          this.$store.dispatch('getusersvotes', voutinguid)
          this.$store.dispatch('fightupdatelistener')
          // getusersvotes(user)
          //  this.$store.dispatch('getusersfantacyfights')
          // this.$store.dispatch('setPurchaseableCertificates')
          // this.getuserrole()
          // ...
        } else {
          // User is signed out
          let signedin = false;
          let voutinguid = ''
          this.$store.dispatch('setSignedIn', signedin);
          // this.$router.push('/frontpage')
          this.$store.dispatch('setgetallfighters')
          this.$store.dispatch('setgetfights')
          this.$store.dispatch('setgetfightsjoin')
          this.$store.dispatch('getusersvotes', voutinguid)
          this.$store.dispatch('fightupdatelistener')
          
          // ...
        }
      });
  },
  // methods: {
  //   async getuserdoc(uid) {
  //     const docRef = doc(db, "users", uid);
  //       const docSnap = await getDoc(docRef);

  //       if (docSnap.exists()) {
  //         console.log("Document data:", docSnap.data());
  //       } else {
  //         // doc.data() will be undefined in this case
  //         console.log("No such document!");
  //       }
  //   }
  // }
  
};
</script>

<style lang="sass">
.v-main 
  background-color: #111111 !important
// .v-main
//   background-image:('./assets/boxingbg.jpeg')!important
//   background-size: cover
// .v-main 
//   background-image: url("./assets/boxingbg.jpeg")
//   background-size: cover
//   background-repeat: no-repeat
//   background-position-x: center
</style>
